var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrush = function SvgBrush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.75 16.75V15.4h-4.5a1.76 1.76 0 0 1-1.269-.531 1.76 1.76 0 0 1-.531-1.27c0-.926.72-1.7 1.629-1.79.054-.01.108-.01.171-.01h13.5c.063 0 .117 0 .171.01.432.036.81.225 1.098.522.369.36.567.873.522 1.43-.081.946-.936 1.639-1.89 1.639H12.25v1.35a2.25 2.25 0 0 1-4.5 0M14.671 1h-3.546a.446.446 0 0 0-.45.45V2.8a.68.68 0 0 1-.675.675.6.6 0 0 1-.225-.045.67.67 0 0 1-.45-.63V1.45a.446.446 0 0 0-.45-.45H7.516a.446.446 0 0 0-.45.45V5.5a.68.68 0 0 1-.675.675.68.68 0 0 1-.675-.675V1.45A.446.446 0 0 0 5.293 1h-.027a2.693 2.693 0 0 0-2.619 2.97l.333 6.075a.906.906 0 0 0 .9.855h12.24a.906.906 0 0 0 .9-.855l.333-6.075A2.697 2.697 0 0 0 14.671 1"
  })));
};
export default SvgBrush;